import React from "react";
import { useNavigate } from "react-router-dom";
import useLayouts from "../../layouts";

const NotFound = () => {
  const { PrivateContentLayout } = useLayouts();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <PrivateContentLayout title="Página No Encontrada">
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
        <div className="text-center max-w-md">
          {/* Icon */}
          <div className="mb-6">
            <svg
              className="mx-auto h-24 w-24 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            404
          </h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            Página No Encontrada
          </h2>

          {/* Description */}
          <p className="text-lg text-gray-600 mb-8">
            La página que estás buscando no existe o ha sido movida. Por favor, verifica la URL o regresa al Dashboard.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleGoBack}
              className="px-6 py-3 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors"
            >
              Volver
            </button>
            <button
              onClick={handleGoToDashboard}
              className="px-6 py-3 bg-black text-[#ffb62a] rounded-lg font-medium hover:bg-primary-600 transition-colors"
            >
              Ir al Dashboard
            </button>
          </div>
        </div>
      </div>
    </PrivateContentLayout>
  );
};

export default NotFound;
